module.exports = __webpack_public_path__ + "f886988f8387779db745406f485ea6b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_12.jpg
// module id = 1661
// module chunks = 5